<div #phoneContainer class="adx-phone-widget-container">
  <!-- Enhanced Status Bar -->
  <div class="adx-enhanced-status-bar" [ngClass]="{'connected': sipService.isRegistered, 'disconnected': !sipService.isRegistered}">
    <!-- Call Status Info -->
    <div class="adx-active-call-info">
      <!-- When there's an active call -->
      @if (getActiveCall(); as call) {
        <div class="adx-call-status-indicator" (click)="togglePresenceSelector($event)">
          <fa-icon [icon]="getCallStatusIcon(call)"
            [ngClass]="'adx-status-icon-' + call.state + (call.isIncoming ? ' incoming' : '') + (call.isCallWaiting ? ' call-waiting' : '')"
          [matTooltip]="getCallStateText(call)"></fa-icon>
        </div>
        @if (getAccountPhoneNumber()) {
          <span class="adx-sip-phone-number">{{getAccountPhoneNumber()}}</span>
        }
        <span class="adx-call-identity-status">
          @if (call.isConference && call.participants) {
            {{call.participants.length}} {{ 'ASTIMAX.PHONE.WIDGET.CALL.PARTICIPANTS' | translate }} ({{call.participants.join(', ')}})
          }
          @if (!call.isConference) {
            @if (hasOriginallyDialedNumber(call)) {
              {{getCallerDisplayPart(call)}} <fa-icon [icon]="faAngleRight" class="adx-dialed-number-separator"></fa-icon> {{getOriginallyDialedPart(call)}}
            } @else {
              {{getCallDisplayName(call)}}
            }
            @if (call.state === 'call-waiting') {
              <span class="adx-call-waiting-label">
                - {{ 'ASTIMAX.PHONE.WIDGET.CALL.STATE.WAITING' | translate }}
              </span>
            }
          }
        </span>
        @if (shouldShowCallTimer(call)) {
          <span class="adx-call-timer-status">{{getCallDuration(call.id)}}</span>
        }
      }

      <!-- When there are no active calls - show status -->
      @if (!getActiveCall()) {
        <div class="adx-call-status-indicator" (click)="togglePresenceSelector($event)">
          @if (sipService.isRegistered) {
            <fa-icon [icon]="getIdleStatusIcon()"
              [ngClass]="{'adx-status-icon-idle': !isDoNotDisturbEnabled, 'adx-status-icon-dnd': isDoNotDisturbEnabled}"
            [matTooltip]="getStatusTooltip()"></fa-icon>
          }
          @if (!sipService.isRegistered) {
            <fa-icon [icon]="faTimesCircle" class="adx-status-icon-error" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CALL.STATE.NOT_REGISTERED' | translate }}"></fa-icon>
          }
        </div>
        @if (getAccountPhoneNumber()) {
          <span class="adx-sip-phone-number">{{getAccountPhoneNumber()}}</span>
        }
      }

      <!-- Presence Selector Dropdown -->
      @if (showPresenceSelector && sipService.isRegistered) {
        <div class="adx-presence-selector"
          [ngClass]="{'visible': showPresenceSelector}">
          <div class="adx-presence-option"
            [ngClass]="{'selected': !isDoNotDisturbEnabled}"
            (click)="setDoNotDisturb(false)">
            <fa-icon [icon]="faPhoneAlt"></fa-icon>
            <span>{{ 'ASTIMAX.PHONE.WIDGET.PRESENCE_STATE.AVAILABLE' | translate }}</span>
          </div>
          <div class="adx-presence-option"
            [ngClass]="{'selected': isDoNotDisturbEnabled}"
            (click)="setDoNotDisturb(true)">
            <fa-icon [icon]="faBan"></fa-icon>
            <span>{{ 'ASTIMAX.PHONE.WIDGET.PRESENCE_STATE.DO_NOT_DISTURB' | translate }}</span>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Headset Reconnection Notification -->
  @if (showReconnectionNotification) {
    <div class="adx-reconnection-notification">
      <fa-icon [icon]="faInfoCircle" class="adx-notification-icon"></fa-icon>
      <div class="adx-notification-message">
        <span class="adx-notification-title">{{ 'ASTIMAX.PHONE.WIDGET.HEADSET_RECONNECTION.TITLE' | translate }}</span>
        <span class="adx-notification-description">{{ 'ASTIMAX.PHONE.WIDGET.HEADSET_RECONNECTION.DESCRIPTION' | translate }}</span>
      </div>
      <div class="adx-notification-actions">
        <button class="adx-reload-button" (click)="reloadPage()">
          <fa-icon [icon]="faSync"></fa-icon>
          <span>{{ 'ASTIMAX.PHONE.WIDGET.HEADSET_RECONNECTION.RELOAD' | translate }}</span>
        </button>
        <button class="adx-close-notification-button" (click)="hideReconnectionNotification()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
    </div>
  }

  <!-- Audio Input Unavailable Notification -->
  @if (audioInputUnavailable && sipService.isRegistered) {
    <div class="reconnection-notification audio-unavailable-notification">
      <fa-icon [icon]="faMicrophoneSlash" class="notification-icon"></fa-icon>
      <div class="notification-message">
        <span class="notification-title">{{ 'ASTIMAX.PHONE.WIDGET.AUDIO_UNAVAILABLE.TITLE' | translate }}</span>
        <span class="notification-description">{{ 'ASTIMAX.PHONE.WIDGET.AUDIO_UNAVAILABLE.DESCRIPTION' | translate }}</span>
      </div>
    </div>
  }

  <!-- Video Upgrade Request Notification -->
  @if (videoUpgradeRequest) {
    <div class="adx-reconnection-notification video-upgrade-notification">
      <fa-icon [icon]="faVideo" class="adx-notification-icon"></fa-icon>
      <div class="adx-notification-message">
        <span class="adx-notification-title">{{ 'ASTIMAX.PHONE.WIDGET.VIDEO.UPGRADE_REQUEST.TITLE' | translate }}</span>
        <span class="adx-notification-description">{{ 'ASTIMAX.PHONE.WIDGET.VIDEO.UPGRADE_REQUEST.MESSAGE' | translate: {name: videoUpgradeRequest.remoteName} }}</span>
      </div>
      <div class="adx-notification-actions">
        <button class="adx-reload-button" (click)="acceptVideoUpgrade()">
          <fa-icon [icon]="faVideo"></fa-icon>
          <span>{{ 'ASTIMAX.PHONE.WIDGET.VIDEO.UPGRADE_REQUEST.ACCEPT_VIDEO' | translate }}</span>
        </button>
        <button class="adx-reload-button" (click)="declineVideoUpgrade()">
          <fa-icon [icon]="faPhoneAlt"></fa-icon>
          <span>{{ 'ASTIMAX.PHONE.WIDGET.VIDEO.UPGRADE_REQUEST.AUDIO_ONLY' | translate }}</span>
        </button>
      </div>
    </div>
  }

  <!-- Minimal Mode Controls -->
  @if (isTooSmall && sipService.isRegistered) {
    <div class="adx-minimal-content">
      <!-- For active calls -->
      @if (getActiveCall(); as call) {
        <div class="adx-minimal-actions-container">
          <!-- Incoming call controls -->
          @if (call.isIncoming && call.state === 'ringing') {
            <div class="adx-mini-row">
              <!-- Show two accept buttons for video calls -->
              @if (call.hasRemoteVideo) {
                <button mat-icon-button class="adx-mini-button primary" (click)="acceptCall()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_VIDEO' | translate }}">
                  <fa-icon [icon]="faVideo"></fa-icon>
                </button>
                <button mat-icon-button class="adx-mini-button primary" (click)="acceptCallAudioOnly()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_AUDIO_ONLY' | translate }}">
                  <fa-icon [icon]="faPhoneAlt"></fa-icon>
                </button>
              }
              <!-- Show single accept button for audio-only calls -->
              @if (!call.hasRemoteVideo) {
                <button mat-icon-button class="adx-mini-button primary" (click)="acceptCall()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT' | translate }}">
                  <fa-icon [icon]="faPhoneAlt"></fa-icon>
                </button>
              }
              <button mat-icon-button class="adx-mini-button warn" (click)="endCall(call.id)" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.REJECT' | translate }}">
                <fa-icon [icon]="faPhoneSlash"></fa-icon>
              </button>
            </div>
          }
          <!-- Call waiting controls -->
          @if (call.isIncoming && call.state === 'call-waiting') {
            <div class="adx-mini-row">
              <!-- Show two accept buttons for video calls -->
              @if (call.hasRemoteVideo) {
                <button mat-icon-button class="adx-mini-button primary" (click)="acceptCallWaiting(call.id, false)" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_VIDEO' | translate }}">
                  <fa-icon [icon]="faVideo"></fa-icon>
                </button>
                <button mat-icon-button class="adx-mini-button primary" (click)="acceptCallWaiting(call.id, true)" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_AUDIO_ONLY' | translate }}">
                  <fa-icon [icon]="faPhoneAlt"></fa-icon>
                </button>
              }
              <!-- Show single accept button for audio-only calls -->
              @if (!call.hasRemoteVideo) {
                <button mat-icon-button class="adx-mini-button primary" (click)="acceptCallWaiting(call.id)" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT' | translate }}">
                  <fa-icon [icon]="faPhoneAlt"></fa-icon>
                </button>
              }
              <button mat-icon-button class="adx-mini-button warn" (click)="endCall(call.id)" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.REJECT' | translate }}">
                <fa-icon [icon]="faPhoneSlash"></fa-icon>
              </button>
            </div>
          }
          <!-- Active call controls -->
          @if (!(call.isIncoming && (call.state === 'ringing' || call.state === 'call-waiting'))) {
            <!-- All buttons in one row with input -->
            @if (call.state !== 'ringing') {
              <div class="adx-mini-row">
                <input type="tel" class="adx-mini-input" [(ngModel)]="targetNumber" name="phoneNumber" autocomplete="tel" (blur)="onTargetNumberBlur()" placeholder="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.NEW_CALL' | translate }} / {{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.TRANSFER' | translate }}">
                <button mat-icon-button class="adx-mini-button" (click)="openKeypad()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.KEYPAD.TOGGLE' | translate }}">
                  <fa-icon [icon]="faTh"></fa-icon>
                </button>
                @if (call.state === 'connected' || call.state === 'held' || call.state === 'conference') {
                  <button mat-icon-button
                    [ngClass]="{'adx-active-mini': call.isMuted}"
                    (click)="toggleMute(call.id)"
                    [disabled]="call.state === 'held'"
                    class="adx-mini-button"
                    matTooltip="{{ call.isMuted ? ('ASTIMAX.PHONE.WIDGET.CONTROLS.UNMUTE' | translate) : ('ASTIMAX.PHONE.WIDGET.CONTROLS.MUTE' | translate) }}">
                    <fa-icon [icon]="call.isMuted ? faMicrophoneSlash : faMicrophone"></fa-icon>
                  </button>
                }
                @if ((call.state === 'connected' || call.state === 'held') && !call.isConference) {
                  <button mat-icon-button
                    [ngClass]="{'adx-active-mini': call.state === 'held'}"
                    (click)="toggleHold(call.id)"
                    class="adx-mini-button"
                    matTooltip="{{ call.state === 'held' ? ('ASTIMAX.PHONE.WIDGET.CONTROLS.RESUME' | translate) : ('ASTIMAX.PHONE.WIDGET.CONTROLS.HOLD' | translate) }}">
                    <fa-icon [icon]="call.state === 'held' ? faPlay : faPause"></fa-icon>
                  </button>
                }
                <button mat-icon-button (click)="endCall(call.id)" class="adx-mini-button warn" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.END' | translate }}">
                  <fa-icon [icon]="faPhoneSlash"></fa-icon>
                </button>
                <!-- Bridge and Conference buttons -->
                @if (canBridge) {
                  <button mat-icon-button
                    [disabled]="!canBridge"
                    (click)="bridgeCalls()"
                    class="adx-mini-button"
                    matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.BRIDGE_CALLS' | translate }}">
                    <fa-icon [icon]="faLink"></fa-icon>
                  </button>
                }
                @if (canCreateConference) {
                  <button mat-icon-button
                    [disabled]="!canCreateConference"
                    (click)="createConference()"
                    class="adx-mini-button"
                    matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.CREATE_CONFERENCE' | translate }}">
                    <fa-icon [icon]="faUsers"></fa-icon>
                  </button>
                }
                <!-- New Call and Transfer buttons -->
                @if (targetNumber) {
                  @if (canMakeCall()) {
                    <button mat-icon-button
                      [disabled]="!targetNumber"
                      (click)="startCall(false)"
                      class="adx-mini-button"
                      matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.NEW_CALL' | translate }}">
                      <fa-icon [icon]="faPhoneAlt"></fa-icon>
                    </button>
                  }
                  <button mat-icon-button
                    [disabled]="call.state === 'transferring'"
                    (click)="blindTransfer(call.id, targetNumber)"
                    class="adx-mini-button"
                    matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.TRANSFER' | translate }}">
                    <fa-icon [icon]="faExchangeAlt"></fa-icon>
                  </button>
                }
              </div>
            }
            <!-- For outgoing ringing calls, just show a button to end the call -->
            @if (call.state === 'ringing') {
              <div class="adx-mini-row">
                <button mat-icon-button (click)="endCall(call.id)" class="adx-mini-button warn" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.END' | translate }}">
                  <fa-icon [icon]="faPhoneSlash"></fa-icon>
                </button>
              </div>
            }
          }
        </div>
      }
      <!-- For no active calls - mini dialer -->
      @if (!activeCalls.length) {
        <div class="adx-mini-row">
          <input type="tel" class="adx-mini-input" [(ngModel)]="targetNumber" name="phoneNumber" autocomplete="tel" (blur)="onTargetNumberBlur()" placeholder="{{ 'ASTIMAX.PHONE.WIDGET.CALL.TARGET.NUMBER' | translate }}">
          <button mat-icon-button class="adx-mini-button" (click)="openKeypad()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.KEYPAD.TOGGLE' | translate }}">
            <fa-icon [icon]="faTh"></fa-icon>
          </button>
          <button mat-icon-button
            [disabled]="(!targetNumber && !hasLastDialedNumber) || audioInputUnavailable"
            (click)="startCall(false)" class="adx-mini-button"
            matTooltip="{{ audioInputUnavailable ? ('ASTIMAX.PHONE.WIDGET.AUDIO_UNAVAILABLE.TITLE' | translate) : ('ASTIMAX.PHONE.WIDGET.CONTROLS.CALL' | translate) }}">
            <fa-icon [icon]="faPhoneAlt"></fa-icon>
          </button>
        </div>
      }
    </div>
  }

  <!-- Main Phone Content - Hidden when widget is too small -->
  @if (sipService.isRegistered) {
    <div class="adx-phone-content" [ngClass]="{'hidden': isTooSmall}">
      <!-- Active Call View - Shows when there's at least one active call -->
      @if (activeCalls.length > 0) {
        <div class="adx-active-calls-container">
          <!-- Side-by-side layout container - Hidden during video calls -->
          @if (!hasActiveVideoCall) {
            <div class="adx-side-by-side-container">
              <!-- Calls List - Only visible when there are multiple calls -->
              @if (activeCalls.length > 1) {
                <div class="adx-calls-list-container">
                  <div class="adx-calls-header">
                    <span>{{ 'ASTIMAX.PHONE.WIDGET.CALL.ACTIVE_CALLS' | translate }} ({{activeCalls.length}})</span>
                  </div>
                  <div class="adx-calls-list">
                    @for (call of activeCalls; track call) {
                      <mat-card
                     [ngClass]="{'adx-active-call': call.id === activeCallId && call.state === 'connected', 
                                 'adx-held-call': call.state === 'held',
                                 'adx-incoming-call': call.isIncoming && call.state === 'ringing',
                                 'adx-call-waiting-call': call.isIncoming && call.state === 'call-waiting',
                                 'adx-outgoing-call': !call.isIncoming && call.state === 'ringing',
                                 'adx-conference-call': call.isConference}"
                      (click)="selectCall(call.id)">
                      <div class="adx-call-info-container">
                        <!-- Call Details -->
                        <div class="adx-call-details">
                          <!-- Status indicator icon -->
                          <div class="adx-call-status-indicator">
                            <fa-icon [icon]="getCallStatusIcon(call)"
                              [ngClass]="'adx-status-icon-' + call.state + (call.isIncoming ? ' incoming' : '') + (call.isCallWaiting ? ' call-waiting' : '')"
                            [matTooltip]="getCallStateText(call)"></fa-icon>
                          </div>
                          <!-- Call Identity -->
                          <div class="adx-call-identity">
                            @if (hasOriginallyDialedNumber(call)) {
                              {{getCallerDisplayPart(call)}} <fa-icon [icon]="faAngleRight" class="adx-dialed-number-separator"></fa-icon> {{getOriginallyDialedPart(call)}}
                            } @else {
                              {{ getCallDisplayName(call) }}
                            }
                            @if (call.state === 'call-waiting') {
                              <span class="adx-call-waiting-badge">
                                {{ 'ASTIMAX.PHONE.WIDGET.CALL.STATE.WAITING' | translate }}
                              </span>
                            }
                          </div>
                          <!-- Call Timer -->
                          @if (shouldShowCallTimer(call)) {
                            <div class="adx-call-timer">
                              {{ getCallDuration(call.id) }}
                            </div>
                          }
                          <!-- Conference participants - Only show for conference calls -->
                          @if (call.isConference && call.participants && call.participants.length > 0) {
                            <div class="adx-conference-info">
                              <span>{{ call.participants.length }} {{ 'ASTIMAX.PHONE.WIDGET.CALL.PARTICIPANTS' | translate }}</span>
                            </div>
                          }
                        </div>
                      </div>
                    </mat-card>
                  }
                </div>
              </div>
            }
            <!-- Active Call Controls - Always visible when there's a call -->
            <div class="adx-call-controls-container" [ngClass]="{'full-width': activeCalls.length <= 1}">
              @if (getActiveCall(); as call) {
                <!-- Main Actions Container -->
                <div class="adx-main-actions-container">
                  <!-- Transfer & Call Actions -->
                  @if (call.state !== 'ringing' && call.state !== 'call-waiting' && !call.isConference) {
                    <div class="adx-transfer-actions">
                      <mat-form-field appearance="outline" class="adx-transfer-input">
                        <mat-label>{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.NEW_CALL' | translate }} / {{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.TRANSFER' | translate }}</mat-label>
                        <input matInput [(ngModel)]="targetNumber" name="phoneNumber" autocomplete="tel" (blur)="onTargetNumberBlur()" placeholder="{{ 'ASTIMAX.PHONE.WIDGET.CALL.TARGET.ENTER_NUMBER' | translate }}" type="tel">
                        @if (targetNumber) {
                          <button matSuffix mat-icon-button (click)="targetNumber=''">
                            <fa-icon [icon]="faTimes"></fa-icon>
                          </button>
                        }
                        <button matSuffix mat-icon-button class="adx-keypad-open" (click)="openKeypad()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.KEYPAD.TOGGLE' | translate }}">
                          <fa-icon [icon]="faTh"></fa-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  }
                  <!-- Call Actions Bar -->
                  <div class="adx-call-actions-bar">
                    <!-- Incoming Call Controls -->
                    @if (call.isIncoming && call.state === 'ringing') {
                      <!-- Show two accept buttons for video calls -->
                      @if (call.hasRemoteVideo) {
                        <button mat-raised-button (click)="acceptCall()" class="adx-call-action-btn primary">
                          <fa-icon [icon]="faVideo"></fa-icon>
                          <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_VIDEO' | translate }}</span>
                        </button>
                        <button mat-raised-button (click)="acceptCallAudioOnly()" class="adx-call-action-btn primary">
                          <fa-icon [icon]="faPhoneAlt"></fa-icon>
                          <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_AUDIO_ONLY' | translate }}</span>
                        </button>
                      }
                      <!-- Show single accept button for audio-only calls -->
                      @if (!call.hasRemoteVideo) {
                        <button mat-raised-button (click)="acceptCall()" class="adx-call-action-btn primary">
                          <fa-icon [icon]="faPhoneAlt"></fa-icon>
                          <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT' | translate }}</span>
                        </button>
                      }
                      <button mat-raised-button (click)="endCall(call.id)" class="adx-call-action-btn warn">
                        <fa-icon [icon]="faPhoneSlash"></fa-icon>
                        <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.REJECT' | translate }}</span>
                      </button>
                    }
                    <!-- Call Waiting Controls -->
                    @if (call.isIncoming && call.state === 'call-waiting') {
                      <!-- Show two accept buttons for video calls -->
                      @if (call.hasRemoteVideo) {
                        <button mat-raised-button (click)="acceptCallWaiting(call.id, false)" class="adx-call-action-btn primary">
                          <fa-icon [icon]="faVideo"></fa-icon>
                          <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_VIDEO' | translate }}</span>
                        </button>
                        <button mat-raised-button (click)="acceptCallWaiting(call.id, true)" class="adx-call-action-btn primary">
                          <fa-icon [icon]="faPhoneAlt"></fa-icon>
                          <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT_AUDIO_ONLY' | translate }}</span>
                        </button>
                      }
                      <!-- Show single accept button for audio-only calls -->
                      @if (!call.hasRemoteVideo) {
                        <button mat-raised-button (click)="acceptCallWaiting(call.id)" class="adx-call-action-btn primary">
                          <fa-icon [icon]="faPhoneAlt"></fa-icon>
                          <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ACCEPT' | translate }}</span>
                        </button>
                      }
                      <button mat-raised-button (click)="endCall(call.id)" class="adx-call-action-btn warn">
                        <fa-icon [icon]="faPhoneSlash"></fa-icon>
                        <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.REJECT' | translate }}</span>
                      </button>
                    }
                    <!-- Active Call Controls -->
                    @if (!(call.isIncoming && (call.state === 'ringing' || call.state === 'call-waiting'))) {
                      @if (call.state === 'connected' || call.state === 'held' || call.state === 'conference') {
                        <button mat-icon-button class="primary"
                          [ngClass]="{'adx-active-control': call.isMuted}"
                          (click)="toggleMute(call.id)"
                          [disabled]="call.state === 'held'"
                          matTooltip="{{ call.isMuted ? ('ASTIMAX.PHONE.WIDGET.CONTROLS.UNMUTE' | translate) : ('ASTIMAX.PHONE.WIDGET.CONTROLS.MUTE' | translate) }}">
                          <fa-icon [icon]="call.isMuted ? faMicrophoneSlash : faMicrophone"></fa-icon>
                        </button>
                      }
                      @if ((call.state === 'connected' || call.state === 'held') && !call.isConference) {
                        <button mat-icon-button class="primary"
                          [ngClass]="{'adx-active-control': call.state === 'held'}"
                          (click)="toggleHold(call.id)"
                          matTooltip="{{ call.state === 'held' ? ('ASTIMAX.PHONE.WIDGET.CONTROLS.RESUME' | translate) : ('ASTIMAX.PHONE.WIDGET.CONTROLS.HOLD' | translate) }}">
                          <fa-icon [icon]="call.state === 'held' ? faPlay : faPause"></fa-icon>
                        </button>
                      }
                      <button mat-raised-button (click)="endCall(call.id)" class="adx-call-action-btn warn">
                        <fa-icon [icon]="faPhoneSlash"></fa-icon>
                        <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.END' | translate }}</span>
                      </button>
                      <!-- Upgrade to Video Button -->
                      <!-- Only show if: not currently video, and upgrade is available (canUpgradeToVideo=true) -->
                      <!-- canUpgradeToVideo is set when dormant video was negotiated (for both caller and callee) -->
                      <!-- Disabled when there's a pending video upgrade request (other party requested first) -->
                      @if (!call.hasVideo && call.canUpgradeToVideo === true) {
                        <button mat-stroked-button
                          (click)="upgradeToVideo(call.id)"
                          [disabled]="videoUpgradeRequest?.callId === call.id"
                          class="adx-call-action-btn"
                          matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ADD_VIDEO' | translate }}">
                          <fa-icon [icon]="faVideo"></fa-icon>
                          <span class="adx-action-label">{{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.ADD_VIDEO' | translate }}</span>
                        </button>
                      }
                      <!-- Transfer Buttons -->
                      @if (call.state !== 'ringing' && call.state !== 'call-waiting' && !call.isConference) {
                        <div class="adx-action-button-row">
                          @if (targetNumber && canMakeCall()) {
                            <button mat-stroked-button
                              [disabled]="!targetNumber"
                              (click)="startCall(false)"
                              >
                              <fa-icon [icon]="faPhoneAlt"></fa-icon> {{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.NEW_CALL' | translate }}
                            </button>
                          }
                          @if (targetNumber) {
                            <button mat-stroked-button
                              [disabled]="!targetNumber || call.state === 'transferring'"
                              (click)="blindTransfer(call.id, targetNumber)"
                              >
                              <fa-icon [icon]="faExchangeAlt"></fa-icon> {{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.TRANSFER' | translate }}
                            </button>
                          }
                        </div>
                      }
                      <!-- Multi-call actions -->
                      @if (activeCalls.length > 1) {
                        <div class="adx-action-button-row">
                          @if (canBridge) {
                            <button mat-stroked-button
                              [disabled]="!canBridge"
                              (click)="bridgeCalls()"
                              >
                              <fa-icon [icon]="faLink"></fa-icon> {{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.BRIDGE_CALLS' | translate }}
                            </button>
                          }
                          @if (canCreateConference) {
                            <button mat-stroked-button
                              [disabled]="!canCreateConference"
                              (click)="createConference()"
                              >
                              <fa-icon [icon]="faUsers"></fa-icon> {{ 'ASTIMAX.PHONE.WIDGET.CONTROLS.CREATE_CONFERENCE' | translate }}
                            </button>
                          }
                        </div>
                      }
                    }
                  </div>

                </div>
              }
            </div>
          </div>
          }
          <!-- Video Display Section (Conditional) -->
          @if (hasActiveVideoCall && activeCallId) {
            <div #videoSection class="video-section" (mousemove)="onVideoAreaMouseMove()">
              <app-video-display
                [call]="getActiveCall()"
                [layout]="isVideoFullscreen ? 'fullscreen' : 'pip'"
                [showControls]="true"
                [controlsVisible]="areVideoControlsVisible"
                [callDuration]="activeCallId ? getCallDuration(activeCallId) : '00:00:00'"
                [dtmfKey]="lastDtmfKey"
                (dtmfInput)="onMobileDtmfInput($event)"
                (fullscreenToggle)="toggleVideoFullscreen()"
                (undockRequest)="undockVideo()"
                (closeVideo)="downgradeToAudio(activeCallId!)">
              </app-video-display>
              <app-video-controls
                [call]="getActiveCall()"
                [availableCameras]="availableCameras"
                [autoHide]="true"
                [alwaysVisible]="false"
                (videoMuteToggle)="toggleVideoMute(activeCallId!)"
                (audioMuteToggle)="toggleMute(activeCallId!)"
                (cameraSwitch)="switchCamera(activeCallId!, $event)"
                (fullscreenToggle)="toggleVideoFullscreen()"
                (undockRequest)="undockVideo()"
                (settingsOpen)="openVideoSettings()"
                (endCall)="endCall(activeCallId!)"
                (disableVideo)="downgradeToAudio(activeCallId!)"
                (visibilityChange)="onVideoControlsVisibilityChange($event)">
              </app-video-controls>
            </div>
          }
          <!-- Audio Elements - Create for ALL calls that should play audio, not just the UI active call -->
          <div class="media-elements">
            @for (call of activeCalls; track trackByCallId($index, call)) {
              @if (shouldPlayAudio(call)) {
                <audio [srcObject]="call.remoteStream"
                  autoplay
                  [attr.data-call-id]="call.id">
                </audio>
              }
            }
          </div>
        </div>
      }
      <!-- Dialer View - Shows when there are no active calls -->
      @if (!activeCalls.length) {
        <div class="dialer-container">
          <div style="display: flex; align-items: center;">
            <mat-form-field appearance="outline" class="adx-number-input-field">
              <mat-label>{{ 'ASTIMAX.PHONE.WIDGET.CALL.TARGET.NUMBER' | translate }}</mat-label>
              <input matInput [(ngModel)]="targetNumber" name="phoneNumber" autocomplete="tel" (blur)="onTargetNumberBlur()" placeholder="{{ 'ASTIMAX.PHONE.WIDGET.CALL.TARGET.ENTER_NUMBER' | translate }}" type="tel">
              @if (targetNumber) {
                <button matSuffix mat-icon-button (click)="targetNumber=''">
                  <fa-icon [icon]="faTimes"></fa-icon>
                </button>
              }
              @if (!targetNumber && hasLastDialedNumber) {
                <button matSuffix mat-icon-button (click)="redialLastNumber()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CALL.TARGET.REDIAL_LAST_NUMBER' | translate }}">
                  <fa-icon [icon]="faRedoAlt"></fa-icon>
                </button>
              }
              <button matSuffix mat-icon-button class="adx-keypad-open" (click)="openKeypad()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.KEYPAD.TOGGLE' | translate }}">
                <fa-icon [icon]="faTh"></fa-icon>
              </button>
            </mat-form-field>
            <div class="dialer-actions">
              <button mat-raised-button
                [disabled]="(!targetNumber && !hasLastDialedNumber) || audioInputUnavailable"
                (click)="startCall(false)" class="adx-call-button primary">
                <fa-icon [icon]="faPhoneAlt"></fa-icon>
                <span class="adx-action-label">{{ getButtonText(false) }}</span>
              </button>
              <button mat-raised-button
                [disabled]="(!targetNumber && !hasLastDialedNumber) || !canStartVideoCall || audioInputUnavailable"
                (click)="startVideoCall()"
                class="adx-call-button accent"
                matTooltip="{{ canStartVideoCall ? ('ASTIMAX.PHONE.WIDGET.CONTROLS.START_VIDEO_CALL' | translate) : ('ASTIMAX.PHONE.WIDGET.CONTROLS.CAMERA_NOT_AVAILABLE' | translate) }}">
                <fa-icon [icon]="faVideo"></fa-icon>
                <span class="adx-action-label">{{ getButtonText(true) }}</span>
              </button>
            </div>
          </div>

        </div>
      }
    </div>
  }
</div>
